export default ({transaction: {computedType = ''} = {}} = {}) => computedType;
